import { Component, OnInit, ViewEncapsulation } from "@angular/core";
import Swal from "sweetalert2";
import { FormControl } from "@angular/forms";
import { Router } from "@angular/router";
import { User, UserService } from "../../../shared";
import { environment } from "../../../../environments/environment";

@Component({
  selector: "settings-page",
  templateUrl: "./settings.component.html",
  styleUrls: [
    "./settings.component.scss",
    "../../../../assets/icon/icofont/css/icofont.scss",
    "../../../../../node_modules/sweetalert2/src/sweetalert2.scss",
  ],
  encapsulation: ViewEncapsulation.None,
})
export class SettingsComponent implements OnInit {
  // set input fields as independent values
  public usernameSettingsField = new FormControl();
  public emailSettingsField = new FormControl();
  public passwordSettingsField = new FormControl();
  public imageSettingsField = new FormControl();
  public bioSettingsField = new FormControl();

  // other variables
  public isProduction: boolean = environment.production;
  public currentUser: User;
  public user: User = new User();
  public errors: Object = {};
  public isSubmitting: boolean = false;

  constructor(private router: Router, private userService: UserService) {
    this.userService.currentUser.subscribe((userData: User) => {
      this.currentUser = userData;
    });
  }

  ngOnInit() {
    this.populateFields();
    this.updateFormOnChanges();
  }

  public updateFormOnChanges() {
    this.usernameSettingsField.valueChanges.subscribe((value) => {
      this.updateUser("username", value);
    });

    this.emailSettingsField.valueChanges.subscribe((value) => {
      this.updateUser("email", value);
    });

    this.passwordSettingsField.valueChanges.subscribe((value) => {
      this.updateUser("password", value);
    });

    this.imageSettingsField.valueChanges.subscribe((value) => {
      this.updateUser("image", value);
    });

    this.bioSettingsField.valueChanges.subscribe((value) => {
      this.updateUser("bio", value);
    });
  }

  public updateUser(key: string, value: Object) {
    if (value !== undefined) {
      this.user[key] = value;
    }
  }

  public populateFields() {
    if (this.currentUser.username !== undefined) {
      this.usernameSettingsField.setValue(this.currentUser.username);
    }

    if (this.currentUser.email !== undefined) {
      this.emailSettingsField.setValue(this.currentUser.email);
    }

    if (this.currentUser.image !== undefined) {
      this.imageSettingsField.setValue(this.currentUser.image);
    }

    if (this.currentUser.bio !== undefined) {
      this.bioSettingsField.setValue(this.currentUser.bio);
    }
  }

  public clearFormFields() {
    this.usernameSettingsField.setValue(null);
    this.emailSettingsField.setValue(null);
    this.passwordSettingsField.setValue(null);
    this.imageSettingsField.setValue(null);
    this.bioSettingsField.setValue(null);
  }

  logout() {
    this.userService.logOut().subscribe(() => {
      this.userService.purgeAuth();
      this.router.navigateByUrl("/");
    });
  }

  public saveImage(url) {
    this.imageSettingsField.setValue(url);
  }

  public openSettingSaveConfirmation() {
    Swal.fire({
      title: "Save these changes to your settings?",
      type: "info",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, save settings!",
    }).then((result) => {
      if (result.value) {
        this.saveSettings();
      }
    });
  }

  public fireSuccessAlert() {
    Swal.fire("Saved", "Your settings have been saved.", "success");
  }

  public fireErrorAlert() {
    Swal.fire("Drama", "There were errors with your submission.", "warning");
    window.scrollTo(0, 0);

    function errorAlert() {
      Swal.close();
    }
    setTimeout(errorAlert, 3000);
  }

  public saveSettings() {
    this.isSubmitting = true;

    this.userService.update(this.user).subscribe(
      (updatedUser) => {
        this.fireSuccessAlert();
        this.clearFormFields();
        this.router.navigateByUrl("/profile/" + updatedUser.username);
      },
      (err) => {
        this.errors = err;
        this.isSubmitting = false;
        this.fireErrorAlert();
      }
    );
  }
}
